export default __webpack_public_path__ + "static/media/CR.6cb2b552.svg";